(() => {
  function init(root = document) {
    root.querySelectorAll('[data-industry-library]').forEach((library) => {
      if (library.dataset.ready) return;
      library.dataset.ready = 'true';
      const input = library.querySelector('[data-industry-search]');
      const cards = [...library.querySelectorAll('[data-industry-card]')];
      const clear = library.querySelector('[data-industry-clear]');
      library.querySelector('[data-industry-tools]').hidden = false;
      function filter() {
        const words = input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
        let count = 0;
        cards.forEach(card => {
          card.hidden = !words.every(word => card.dataset.industryCard.toLocaleLowerCase().includes(word));
          if (!card.hidden) count++;
        });
        library.querySelector('[data-industry-count]').textContent = `${count} ${count === 1 ? 'industry' : 'industries'}`;
        library.querySelector('[data-industry-empty]').hidden = count > 0;
        clear.hidden = words.length === 0;
      }
      input.addEventListener('input', filter);
      clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (window.sscIndustryDownloadsReady) return;
  window.sscIndustryDownloadsReady = true;
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-industry-download]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.dataset.busy) return;
    link.dataset.busy = 'true';
    link.setAttribute('aria-busy', 'true');
    const status = link.closest('.pi-site').querySelector('[data-industry-download-status]');
    if (status) status.textContent = 'Preparing your flyer…';
    try {
      const response = await fetch(link.href, { signal: AbortSignal.timeout(20000) });
      if (!response.ok) throw new Error('Download failed');
      const blob = await response.blob();
      if (!blob.size || !(await blob.slice(0, 5).text()).startsWith('%PDF-')) throw new Error('Not a PDF');
      const url = URL.createObjectURL(blob);
      const download = document.createElement('a');
      download.href = url;
      download.download = link.dataset.industryDownload;
      document.body.append(download); download.click(); download.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      if (status) status.textContent = 'Your flyer download has started.';
    } catch {
      if (status) status.textContent = 'Opening the PDF so you can save it from your browser.';
      window.location.assign(link.href);
    } finally {
      delete link.dataset.busy; link.removeAttribute('aria-busy');
    }
  });
})();
